module.exports = __webpack_public_path__ + "img/V9.3d2392ff.jpg";